<template>
  <form id="basket-order-form" data-validate="true" onsubmit="(function() {return false;})()">

    <!--<div class="js-cart-auth-message cart-auth-message" v-if="!user.id">
      <p
          class="cart-auth-message__text"
      >Зарегистрируйтесь и&nbsp;получите все преимущества регистрации</p>
      <button
          class="btn btn&#45;&#45;white cart-auth-message__btn"
          type="button"
          onclick="document.location.href = '/auth-registration/'"
      >Зарегистрироваться
      </button>
    </div>
    <br/>-->
    <!-- TODO
      <a href="javascript:;" class="cart__signboard" title="Подсказка баннера">
          <picture class="cart__signboard-pic picture">
              <source media="(max-width: 414px)" data-srcset="../../images/content/banner_1_414.jpg">
              <img class="picture__img lazyload" data-src="../../images/content/banner_1.jpg" data-sizes="976" alt="">
          </picture>
      </a>
    -->

    <div class="cart-form">
      <div class="cart-top cart-section">
        <div class="cart-top__block">
          <p class="cart-top__caption">В корзине <span :inner-html.prop="basketItems.length"></span> товара
            на сумму <span :inner-html.prop="total.basePrice | price"></span>,  итого с учетом скидки  <span :inner-html.prop="total.totalPrice | price"></span></p>
        </div>
        <div class="cart-top__return">
          <a href="#" @click.prevent="setCurrentTab('basket')">Вернуться в корзину</a>
        </div>
        <div class="cart__delivery-notice">
            При сумме заказа с учетом скидок от {{ freeDeliverySum }} руб. доставка 2–14 руб. в зависимости от региона
        </div>
        <div class="cart__outlet-notice" v-if="outletBasketTypes.length > 1">
          В корзине есть товары из раздела Outlet. Эти товары будут помещены в отдельный заказ.
        </div>
      </div>

      <div class="cart-personal cart-section">
        <p class="cart__block-title container-tablet-lg">Личные данные</p>
        <p class="cart-personal__sub-title">Поля, отмеченные <span class="circle"></span> обязательны для заполнения</p>

        <div id="cart-address-current" class="js-radio-tab-body cart-form__tab is-visible">
          <div class="container-tablet-lg cart-personal__fields">
            <div class="field field--client-name cart-form__field cart-personal__field required">
              <input
                  v-model="form.firstName"
                  class="field__input"
                  type="text"
                  name="client-name"
                  id="field-client-name"
                  value=""
                  data-parsley-name
                  @input="onInput"
                  required
              />
              <label class="field__label" for="field-client-name">Имя</label>
            </div>
            <div class="field field--client-surname cart-form__field cart-personal__field required">
              <input
                  v-model="form.lastName"
                  class="field__input"
                  type="text"
                  name="client-surname"
                  id="field-client-surname"
                  value=""
                  data-parsley-name
                  @input="onInput"
                  required
              />
              <label class="field__label" for="field-client-surname">Фамилия</label>
            </div>

            <div class="cart-form__field-wrapper cart-personal__field required">
              <div class="field field--tel cart-form__field">
                <input
                    v-model="form.phone"
                    class="field__input"
                    type="tel"
                    name="tel"
                    id="field-tel"
                    data-parsley-tel
                    @input="onInput"
                    placeholder="+7(000) 000-00-00"
                    v-mask="'+7(###) ###-##-##'"
                    required
                />
                <label class="field__label field__label--up" for="field-tel">Телефон</label>
              </div>
              <div
                  class="cart-form__field-tooltip tooltip tooltip--message"
                  data-tooltip-text="Номер телефона позволит Вам получать новую свежую информацию от нас"
              >
                <button
                    type="button"
                    class="tooltip__trigger cart-form__field-tooltip-btn"
                >Зачем нужен номер телефона?
                </button>
              </div>
            </div>
            <div class="field field--email cart-form__field cart-personal__field required">
              <input
                  v-model="form.email"
                  class="field__input"
                  type="email"
                  name="email"
                  id="field-email"
                  @input="onInput"
                  value=""
                  required
              />
              <label class="field__label" for="field-email">Электронная почта</label>
            </div>
          </div>
        </div>
      </div>

      <div class="cart-delivery cart-section">
        <p class="cart__block-title container-tablet-lg">Доставка</p>
        <!-- На name="radio-delivery-type" навешивается логика табок (при нажатии на "самовывоз", открывается яндекс-карта) -->
        <div class="cart-form__delivery-types">
          <div class="container-tablet-lg cart-form__custom-radio-table">
            <div v-if="Object.keys(deliveryTypes).length === 1" v-for="deliveryType in Object(deliveryTypes)">
              <div class="cart-form__delivery-info">
                <div class="cart-form__delivery-info-caption">
                    <!-- TODO: task_135818 -->
                    <!--  {{ deliveryType.name }} <b>{{ deliveryType.description }}</b> -->
                    <a href="/customers/?faq=444">Сроки доставки</a>
                </div>
                <div class="cart-form__delivery-info-caption" v-if="deliveryType.price.length > 1">
                  Сумма доставки по всем заказам
                </div>
                <div class="cart-form__delivery-info-price">
                    {{ getFullPriceDelivery(deliveryType.price) || 'Бесплатно' }}
                </div>
              </div>
            </div>
            <label v-else
                class="radio radio--radio-default cart-custom-new-check"
                v-for="(deliveryType, index) in Object(deliveryTypes)"
            >
              <input
                  v-model="form.deliveryType"
                  :value="index"
                  type="radio"
                  class="radio__input"
                  name="radio-delivery-type"
                  data-parsley-multiple="radio-delivery-type"
              />
              <p class="radio__label cart-custom-new-check__label">
                <span class="cart-custom-new-check__description">
                  {{ deliveryType.name }}
                </span>
                <span
                    class="cart-custom-new-check__info-item"
                    v-html="deliveryType.description"
                ></span>
              </p>
              <div class="cart-custom-check__info">
                <span class="cart-custom-new-check__info-item cart-custom-new-check__info-item--price">{{deliveryType.price || 'Бесплатно' }}</span>
              </div>
              <span class="cart-custom-check__border"></span>
            </label>
          </div>
          <div class="js-cart-points-map cart__points-map">
            <div class="container-tablet-lg">
              <div class="selected-shop-info">
                <div class="js-selected-shop-info selected-shop-info__content"></div>
                <div class="selected-shop-info__change">
                  <button
                      data-href="#popup-map-select-shop"
                      class="link"
                      type="button"
                      data-popup="open"
                  >Выбрать другой магазин
                  </button>
                </div>
              </div>
              <div
                  id="selected-shop"
                  data-switch="#selected-shop-switch"
                  class="ylist ylist--selected-shop selected-shop"
              >
                <div id="selected-shop-map" class="ylist__map-container is-loading"></div>
              </div>
            </div>
          </div>
        </div>
        <p class="cart__block-title container-tablet-lg" v-if="isNeedAddress">Адрес получателя</p>
          <div class="cart__block-title container-tablet-lg" v-if="isNeedAddress">
              <div id="cantDeliveryMessage" v-show="isCantDelivery">
                  Доставка в данный регион временно недоступна.
              </div>
              <div style="color: red" id="cantTempDeliveryMessage" v-show="isCantTempDelivery && !isClosedToAll">
                  Прием заказов в регионы временно ограничен. Оформить заказ можно с 1 января 2026 (обработка с 12.01).
              </div>
              <div style="color: red"  id="isClosedToAllMessage" v-show="isClosedToAll">
                  Прием заказов временно ограничен. Оформить заказ можно с 1 января 2026 (обработка с 12.01).
              </div>
          </div>
        <div class="cart-form__address cart-personal__fields" v-if="isNeedAddress">
          <div class="field field&#45;&#45;client-name cart-personal__field required cart-form__field cart-form__field cart-form__field--city">
            <VueSuggestions
                id="city"
                :model.sync="inputCity"
                :placeholder="'Начните вводить'"
                class="field__input"
                required
                :options="citySuggestionOptions"
                data-parsley-debounce="500"
            ></VueSuggestions>
            <label class="field__label field__label--up">Населенный пункт</label>
          </div>

          <div class="field field&#45;&#45;client-name cart-personal__field required cart-form__field cart-form__field--street">
            <VueSuggestions
                id="street"
                :model.sync="inputStreet"
                :placeholder="'Начните вводить'"
                class="field__input"
                required
                :options="streetSuggestionOptions"
                data-parsley-debounce="500"
            ></VueSuggestions>
            <label class="field__label field__label--up">Улица</label>
          </div>

          <div class="field field&#45;&#45;client-name cart-personal__field required cart-form__field cart-form__field--house">
            <VueSuggestions
                id="house"
                :model.sync="form.house"
                :placeholder="''"
                class="field__input"
                required
                :options="houseSuggestionOptions"
            ></VueSuggestions>
            <label class="field__label field__label--up">Дом</label>
          </div>

          <div class="field field&#45;&#45;client-name cart-personal__field cart-form__field cart-form__field--room">
            <input
                v-model="form.flat"
                class="field__input"
                type="text"
                name="client-name"
                id="flat"
            />
            <label class="field__label field__label--up" for="flat">Квартира</label>
          </div>
        </div>
      </div>

      <div class="cart-section cart-payment">
        <p class="cart__block-title container-tablet-lg">Оплата</p>
        <div class="container-tablet-lg">
          <fieldset class="radio radio--radio-payment cart-form__radio cart-form__custom-radio-table">
            <div v-if="Object.keys(paymentTypes).length === 1" v-for="paymentType in Object(paymentTypes)">
              <div class="cart-form__delivery-info">
                <div class="cart-form__delivery-info-caption">
                  {{ paymentType.name }}
                </div>
              </div>
            </div>
            <template v-else v-for="(paymentType, index) in Object(paymentTypes)">
              <input
                  v-model="form.paymentType"
                  type="radio"
                  class="radio__input"
                  :id="`radio-radio-payment-${index}`"
                  :value="index"
                  name="radio-radio-payment"
                  checked="checked"
              />
              <label
                  class="radio__label cart-custom-new-radio"
                  :for="`radio-radio-payment-${index}`"
              >{{ paymentType.name }}
              </label>
            </template>
          </fieldset>
        </div>
      </div>

      <div class="cart-total-section">
        <p class="cart__block-title container-tablet-lg">Сведения о заказе</p>
        <div class="cart-total">
          <div class="cart-total__wrapper">
            <div class="cart-total__block">
              <p class="cart-total__caption">Сумма заказа</p>
              <p class="cart-total__price" :inner-html.prop="total.basePrice | price"></p>
            </div>
            <div class="cart-total__block">
              <p class="cart-total__caption">Скидка</p>
              <p class="cart-total__price" :inner-html.prop="total.discount | price"></p>
            </div>
            <div class="cart-total__block" v-for="priceValue in getDeliveryPrice">
              <p class="cart-total__caption">Доставка
                <span v-if="getDeliveryPrice.length > 1 && priceValue.status">
                  Заказ - {{ priceValue.status }}
                </span>
              </p>
              <p class="cart-total__price" :inner-html.prop="priceValue.price | price"></p>
            </div>
            <div class="cart-total__block cart-total__sum">
              <div class="cart-total__sum-caption">Итого к оплате</div>
              <span :inner-html.prop="getTotalPrice | price"></span>
            </div>
          </div>

          <div
              class="cart-total-textarea field field&#45;&#45;client-comment cart-form__field&#45;&#45;long"
          >
            <textarea
                v-model="form.comment"
                class="field__input field__input&#45;&#45;textarea"
                name="client-comment"
                id="field-client-comment"
                rows="1"
            ></textarea>
            <label class="field__label" for="field-client-comment">Комментарий к заказу</label>
          </div>
          <div class="cart__agreements container-tablet-lg">
              <fieldset class="checkbox cart__checkbox">
                  <legend class="is-hidden">Согласие с условиями передачи данных</legend>
                  <input
                          type="checkbox"
                          class="checkbox__input"
                          name="checkbox-agreement"
                          id="checkbox-agreement"
                          value="1"
                          data-parsley-multiple="checkbox-agreement"
                          required
                          checked="checked"
                  />
                  <label class="checkbox__label" for="checkbox-agreement">
                      Я даю&nbsp;
                      <a
                              class="cart__checkbox-link"
                              href="/customers/?agreement_form"
                              target="_blank"
                      >согласие на обработку</a>
                      моих персональных данных ООО «Пьер Фабр» и соглашаюсь с&nbsp;
                      <a
                              class="cart__checkbox-link"
                              href="/customers/?agreement"
                              target="_blank"
                      >
                          Пользовательским соглашением</a>
                      и&nbsp;
                      <a
                              class="cart__checkbox-link"
                              href="/customers/?policy"
                              target="_blank"
                      >
                          Политикой в отношении обработки персональных данных.</a>
                  </label>
              </fieldset>
            <fieldset class="checkbox cart__checkbox">
              <legend class="is-hidden">Согласие с условиями передачи данных</legend>
              <input
                  type="checkbox"
                  class="checkbox__input"
                  name="checkbox-spec"
                  id="checkbox-spec"
                  value="1"
                  data-parsley-multiple="checkbox-spec"
                  checked="checked"
              />
              <label
                  class="checkbox__label tooltip tooltip--message"
                  data-tooltip-text="Подписываясь на рассылку, Вы всегда будете в курсе наших самых выгодных предложений! Самая свежая информация о средствах по уходу за лицом, волосами и телом, отправленная по электронной почте, а также интересные статьи о здоровье и красоте ждут вас."
                  for="checkbox-spec"
              >
                  Даю согласие ООО "Пьер Фабр" на получение новостных и рекламных рассылок.
                <span
                    class="tooltip__trigger cart-form__field-tooltip-btn"
                >Подробнее</span>
              </label>
            </fieldset>
          </div>
          <div class="cart__btn-container">
            <button
                class="btn btn--blue cart__btn"
                type="button"
                @click="createOrder"
            >Оформить заказ
            </button>
          </div>

        </div>
      </div>

    </div>

  </form>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import basketItemsList from './basketItemsList.vue'
import VueSuggestions from 'vue-suggestions'
import initMask from './../../../scripts/mask'
import '../../../scripts/validation'
import initTooltip from '../tooltip'
import freeDeliveryMixin from '../freeDelivery'
import outletMixin from '../outlet'

export default {
  name: 'basket-order',
  components: {basketItemsList, VueSuggestions},
  mixins: [
    freeDeliveryMixin,
    outletMixin,
  ],
  computed: {
    ...mapState(['basketItems', 'total', 'user', 'deliveryTypes', 'paymentTypes']),
    ...mapGetters(['getDeliveryPrice', 'getTotalPrice']),
    isNeedAddress() {
      return this.form.deliveryType !== ''
    },
      isCantDelivery() {
          return this.deliveryTypes[this.form.deliveryType].cantDelivery === true
      },
      isCantTempDelivery() {
          return this.deliveryTypes[this.form.deliveryType].cantTempDelivery === true
      },
      isClosedToAll() {
          return this.deliveryTypes[this.form.deliveryType].isClosedToAll === true
      },
    citySuggestionOptions() {
      const options = Object.assign({}, this.suggestionOptions)
      options['bounds'] = 'city-settlement'
      return options
    },
    streetSuggestionOptions() {
      const options = Object.assign({}, this.suggestionOptions)
      options['bounds'] = 'street'
      options['noSuggestionsHint'] = 'Проверьте написание и выберите улицу из списка'
      return options
    },
    houseSuggestionOptions() {
      const options = Object.assign({}, this.suggestionOptions)
      options['bounds'] = 'house'
      options['triggerSelectOnBlur'] = true
      return options
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.$store.state.form)),
      coordinates: {
        latitude: '',
        longitude: '',
      },
      inputCity: '',
      inputStreet: '',
      inputHouse: '',

      suggestionOptions: {
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
        token: '894dab0fe7381be927bc66430a4ebf0f62335a8b',
        type: 'ADDRESS',
        scrollOnFocus: false,
        triggerSelectOnBlur: false,
        triggerSelectOnEnter: false,
        addon: 'none',
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
        onSelect: this.onSuggest,
      },
    }
  },
  watch: {
    form: {
      handler: function (form) {
        this.$store.commit('updateForm', form)
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['setCurrentTab']),
    getForm: function () {
      return $('#basket-order-form')
    },
    createOrder: function () {
      this.getForm()
          .parsley()
          .validate()

      if (
          !this.getForm()
              .parsley()
              .isValid()
          || this.getForm().attr('cantTempDelivery') == "true"
      ) {
        return
      }

      window.scrollTo({top: 0})

      this.form.address = [this.form.index, this.form.city, this.form.street, this.form.house, this.form.flat]
          .filter((val) => !!val)
          .join(', ')
      $.post(`/api/internal/order/create/`, this.form, result => {
       if(result.isNotAvailable)
       {
            location.reload();
       }
        if (!result.outletLock && result.orders.length === 0){
          this.setCurrentTab('basket')
        } else {
          this.$store.commit('setOutletLock', result.outletLock)
          if (Array.isArray(result.orders)) {
            result.orders.forEach(order => {
              this.$store.commit('setOrder', order)
            })
          }
          this.setCurrentTab('basket-finish')
        }
      })
    },

    onSuggest(suggestion) {
      if (suggestion.data) {
        this.form.address = suggestion.unrestricted_value
        this.selectLocation(suggestion.data)
      }
    },

    selectLocation(location) {
      let city = location.city_with_type;
      if (location.settlement_type === 'мкр' || location.settlement_type === 'р-н') {
          city = city+ ', '+location.settlement_with_type;
      } else {
          city = location.settlement_with_type || location.city_with_type;
      }
      this.form.city = this.inputCity = city
      this.form.street = this.inputStreet = location.street_with_type
      this.form.house = this.inputHouse = location.house
      this.form.index = location.postal_code
      this.restrictSuggestions(location)

      this.calcDelivery(location)
    },

    restrictSuggestions(location) {
      const $street = $('#street'), $house = $('#house')
      const streetConstraints = { locations: {} }, houseConstraints = { locations: {} }
      let restrictStreet = false, restrictHouse = false
      if (location.city_fias_id || location.settlement_fias_id) {
        restrictStreet = true
        restrictHouse = true
        if (location.settlement_fias_id) {
          streetConstraints['locations']['settlement_fias_id'] = location.settlement_fias_id
          houseConstraints['locations']['settlement_fias_id'] = location.settlement_fias_id
        } else if (location.city_fias_id) {
          streetConstraints['locations']['city_fias_id'] = location.city_fias_id
          houseConstraints['locations']['city_fias_id'] = location.city_fias_id
        }
      }
      if (location.street_fias_id) {
        restrictHouse = true
        houseConstraints['locations']['street_fias_id'] = location.street_fias_id
      }
      $street.suggestions().setOptions({
        restrict_value: restrictStreet,
        constraints: streetConstraints,
      })
      $house.suggestions().setOptions({
        restrict_value: restrictHouse,
        constraints: houseConstraints,
      })
    },

    getFullPriceDelivery(arPrice){
      let price = 0;
      for (let item of arPrice||[]) {
        price += item.price;
      }
      return price;
    },

    calcDelivery(dadata) {
      $.post(
          `/api/internal/basket/calcDelivery/${this.form.deliveryType}/`,
          {
            lat: dadata.geo_lat,
            lon: dadata.geo_lon,
            fiasId: dadata.fias_id,
          },
          result => {
            this.$store.commit('updateDeliveryPrice', result)
            this.$store.commit('updateFiasId', dadata.fias_id)
            if (result.cantDelivery) {
                $('#cantDeliveryMessage').show()
            } else {
                $('#cantDeliveryMessage').hide()
            }
              if (result.cantTempDelivery) {
                  if (!result.isClosedToAll) {
                      $('#cantTempDeliveryMessage').show()
                  } else {
                      $('#isClosedToAllMessage').show()
                  }

                  $('#basket-order-form').attr('cantTempDelivery', true);
              } else {
                  $('#cantTempDeliveryMessage').hide();
                  $('#cantTempDeliveryMessage').hide()
                  $('#basket-order-form').attr('cantTempDelivery', false);
              }
          }
      )
    },

    fixInputCity() {
      if (this.inputCity !== this.form.city) {
        this.inputCity = this.form.city
        const $city = $('#city')
        $city.val(this.form.city)
        $city.suggestions().fixData()
      }
    },

    resetInputStreet() {
      if (this.inputStreet !== this.form.street) {
        this.inputStreet = this.form.street = ''
      }
    },

    resetInputHouse() {
        if (this.inputHouse !== this.form.house) {
            this.inputHouse = this.form.house = ''
        }
    },

    onInput(event) {
      if (event.target.value) {
        event.target.classList.add('filled');
      } else {
        event.target.classList.remove('filled');
      }
    }
  },
  mounted() {
    this.getForm().parsley()
    initMask(this.getForm())
    initTooltip()

    const that = this

    const $city = $('#city'), $street = $('#street'), $house = $('#house')
    if (this.user.address.fiasId) {
      const ajaxParams = $city.suggestions().getAjaxParams(
          'findById',
          {
            data: JSON.stringify({ query: this.user.address.fiasId }),
          }
      )
      $.ajax(ajaxParams)
          .done((response) => {
            if (response.suggestions.length) {
              this.selectLocation(response.suggestions[0].data)

              if (this.form.city) {
                if (!this.form.house && this.user.address.house) {
                  this.form.house = this.user.address.house
                }
                if (this.user.address.flat) {
                  this.form.flat = this.user.address.flat
                }
                if (this.user.address.index) {
                  this.form.index = this.user.address.index
                }
              }
            }
          })
    } else {
      $city.suggestions().getGeoLocation().then((location) => {
        this.selectLocation(location)
      })
    }
    $city.blur(function () {
      that.fixInputCity()
    })
    $street.blur(function () {
      that.resetInputStreet()
    })

    if (this.form.firstName.length) {
      $('label[for="field-client-name"]').addClass('field__label--up');
    }
    if (this.form.lastName.length) {
      $('label[for="field-client-surname"]').addClass('field__label--up');
    }
    if (this.form.email.length) {
      $('label[for="field-email"]').addClass('field__label--up');
    }
  },
}
</script>

<style>
.suggestions-nowrap {
  white-space: nowrap;
}

/**
         * Основной INPUT
         */
.suggestions-input {
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
}

.suggestions-input::-ms-clear {
  display: none;
}

.suggestions-wrapper {
  display: inline-block;
  position: absolute;
  margin: 0;
  padding: 0;
  vertical-align: top;
  min-height: 1px;
  -webkit-text-size-adjust: 100%;
}

/**
         * Блок в правой части основного INPUT'а
         * В нем показывается иконка ЗАГРУЗКА
         */
.suggestions-addon {
  display: none;
  opacity: 0;
  position: absolute;
}

.suggestions-addon[data-addon-type='spinner'] {
  background: rgba(255, 255, 255, 0.75) url('data:image/gif;base64,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') 50% 50% no-repeat;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.suggestions-addon[data-addon-type='clear'] {
  background: transparent url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJyBoZWlnaHQ9JzEwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48Zz48cGF0aCBkPSdtMjAsMjBtMTAsMGwyMCwyMGwyMCwtMjBsMTAsMTBsLTIwLDIwbDIwLDIwbC0xMCwxMGwtMjAsLTIwbC0yMCwyMGwtMTAsLTEwbDIwLC0yMGwtMjAsLTIwbDEwLC0xMCcgZmlsbD0nIzk5OScvPjwvZz48L3N2Zz4=') 50% 50% no-repeat;
  background-size: contain;
  cursor: pointer;
  opacity: 0.8;
}

.suggestions-addon[data-addon-type='clear']:hover {
  opacity: 1;
}

/**
         * Выпадающий блок с найденными подсказками
         */
.suggestions-suggestions {
  background: #fff;
  border: 1px solid #999;
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: default;
  z-index: 9999;
  -webkit-text-size-adjust: 100%;
}

.suggestions-suggestions strong {
  font-weight: normal;
  color: #3399ff;
}

.suggestions-suggestions.suggestions-mobile {
  border-style: none;
}

.suggestions-suggestions.suggestions-mobile .suggestions-suggestion {
  border-bottom: 1px solid #ddd;
}

/**
         * Контейнер для одной подсказки
         */
.suggestions-suggestion {
  padding: 4px 4px;
  overflow: hidden;
}

.suggestions-suggestion:hover {
  background: #f7f7f7;
}

/**
         * Выбранная (активная) подсказка
         */
.suggestions-selected {
  background: #f0f0f0;
}

.suggestions-selected:hover {
  background: #f0f0f0;
}

/**
         * Информационный блок в верхней части выпадашки с подсказками
         */
.suggestions-hint {
  padding: 4px 4px;
  white-space: nowrap;
  overflow: hidden;
  color: #777;
  font-size: 85%;
}

/**
         * Ограничения поиска, показываются в левой части основного INPUT'а
         */
.suggestions-constraints {
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  white-space: nowrap !important;
}

.suggestions-constraints:empty {
  display: none !important;
}

.suggestions-constraints li {
  background: #f8f8f8;
  border: 1px solid #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  cursor: default;
  display: inline-block;
  margin: 0 4px 0 0;
  padding: 0 0.5em;
}

.suggestions-constraints li .suggestions-remove {
  height: 1em;
  width: 1em;
  display: inline-block;
  margin: 0 0 0 0.25em;
  background: transparent url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJyBoZWlnaHQ9JzEwMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48Zz48cGF0aCBkPSdtMjAsMjBtMTAsMGwyMCwyMGwyMCwtMjBsMTAsMTBsLTIwLDIwbDIwLDIwbC0xMCwxMGwtMjAsLTIwbC0yMCwyMGwtMTAsLTEwbDIwLC0yMGwtMjAsLTIwbDEwLC0xMCcgZmlsbD0nIzk5OScvPjwvZz48L3N2Zz4=') 50% 50% no-repeat;
  background-size: contain;
  cursor: pointer;
  opacity: 0.8;
}

.suggestions-constraints li .suggestions-remove:hover {
  opacity: 1;
}

.suggestions-constraints li span {
  vertical-align: middle;
}

/**
         * Дополнительный текст в подсказке, который идет второй строкой
         */
.suggestions-subtext {
  color: #777;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/**
         * Размещает дополнительный текст в одну строку с основным текстом подсказки
         */
.suggestions-subtext_inline {
  display: inline-block;
  min-width: 6em;
  vertical-align: bottom;
  margin: 0 0.5em 0 0;
}

/**
         * Разделитель нескольких дополнительных текстов
         */
.suggestions-subtext-delimiter {
  display: inline-block;
  width: 2px;
}

/**
         * Выделяет подсказку
         */
.suggestions-subtext_label {
  margin: 0 0 0 0.25em;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 3px;
  background: #f5f5f5;
  font-size: 85%;
}

.suggestions-value[data-suggestion-status='LIQUIDATED'] {
  position: relative;
}

.suggestions-value[data-suggestion-status='LIQUIDATED']:after {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  content: '';
}

@media (max-width: 1279px) {
  .cart-form {
    padding-left: 40px;
    padding-right: 40px;
  }
}

@media (max-width: 767px) {
  .cart-form {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.cart-form__custom-radio-table {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding-left: 168px;
  padding-right: 168px;
  border-bottom: none;
}

@media (max-width: 767px) {
  .cart-form__custom-radio-table {
    padding-left: 0;
    padding-right: 0;
  }
}

.cart-custom-new-check {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  height: 94px;
  width: 300px;
}

.cart-custom-new-radio {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 16px 48px;
  height: 68px;
  width: 300px;
  border: 1px solid #e5e5e5;
  margin-bottom: 0 !important;
  font-size: 16px !important;
  line-height: 18px !important;
}

.cart-custom-new-radio:before {
  left: 16px !important;
  width: 20px !important;
  height: 20px !important;
}

.cart-custom-new-radio:after {
  left: 26px !important;
  width: 10px !important;
  height: 10px !important;
}

.radio__input:checked + .cart-custom-new-radio {
  border-color: #64c7c3;
}

.cart-custom-new-check:nth-child(2n+1) {
  margin-right: 24px;
}

.cart-custom-new-radio:nth-of-type(2n+1) {
  margin-right: 24px;
}

.cart-custom-check__border {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border: 1px solid #e5e5e5;
}

.radio__input:checked ~ .cart-custom-check__border {
  border-color: #64c7c3;
}

.cart-custom-new-check__label {
  width: auto;
  padding-left: 32px;
}

.cart-custom-new-check__label::before {
  height: 20px;
  width: 20px;
}

.cart-custom-new-check__label::after {
  left: 10px;
  width: 10px;
  height: 10px;
}

.cart-custom-new-check__description {
  font-size: 16px;
  margin-bottom: 8px;
}

.cart-custom-new-check__info-item {
  display: block;
  font-size: 16px;
  font-weight: 500;
}

.cart-custom-new-check__info-item--price {
  color: #64c7c3;
}

.cart-form__delivery-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 32px;
}

.cart-payment .cart-form__delivery-info {
  padding-bottom: 0;
}

.cart-form__delivery-info-caption {
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 8px;
}

.cart-form__delivery-info-price {
  font-size: 16px;
  line-height: 18px;
  color: #64c7c3;
}

.cart-form__address {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 168px;
  padding-right: 168px;
}

.cart-form__field.cart-form__field--city {
  width: 100%;
}

.cart-form__field.cart-form__field--street {
  width: 60%;
}

.cart-form__field.cart-form__field--house {
  width: 16%;
}

@media (max-width: 767px) {
  .cart-form__field.cart-form__field--house {
    flex-basis: 47%;
    max-width: 47%;
  }
}

.cart-form__field.cart-form__field--room {
  width: 16%;
}

@media (max-width: 767px) {
  .cart-form__field.cart-form__field--room {
    flex-basis: 47%;
    max-width: 47%;
  }
}

.cart-section {
  border-bottom: 1px solid #e6e6e6;
}

.cart-top {
  padding-top: 16px;
  padding-bottom: 40px;
  text-align: center;
}

@media (max-width: 767px) {
  .cart-top {
    padding-top: 8px;
    padding-bottom: 32px;
  }
}

.cart-top__block {
  margin-bottom: 16px;
}

.cart-top__caption {
  font-size: 20px;
  line-height: 23px;
}

@media (max-width: 767px) {
  .cart-top__caption {
    font-size: 18px;
    line-height: 20px;
  }
}

.cart-top__caption span {
  font-size: 24px;
  line-height: 28px;
}

@media (max-width: 767px) {
  .cart-top__caption span {
    font-size: 20px;
    line-height: 23px;
  }
}

.cart-top__return a {
  color: #64c7c3;
  font-size: 16px;
  line-height: 18px;
  border-bottom: none;
}

@media (max-width: 767px) {
  .cart-top__return a {
    font-size: 14px;
    line-height: 16px;
  }
}

.cart-personal {
  padding-top: 48px;
  padding-bottom: 48px;
}

@media (max-width: 767px) {
  .cart-personal {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

.cart-personal__sub-title {
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  color: #828282;
  margin-bottom: 32px;
}

@media (max-width: 767px) {
  .cart-personal__sub-title {
    font-size: 14px;
    line-height: 16px;
  }
}

.cart-personal__sub-title .circle {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #64c7c3;
  position: relative;
  top: -8px;
}

.cart-personal__fields {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 168px;
  padding-right: 168px;
}

@media (max-width: 1279px) {
  .cart-personal__fields {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media (max-width: 767px) {
  .cart-personal__fields {
    padding-left: 0;
    padding-right: 0;
  }
}

.cart-personal__field {
  flex-grow: 1;
  flex-basis: 45%;
  position: relative;
}

@media (max-width: 767px) {
  .cart-personal__field {
    flex-basis: 100%;
  }
}

.cart-personal__field .cart-form__field {
  width: 100%;
}

.cart-personal__field:nth-of-type(2n+1) {
  margin-right: 24px;
}

@media (max-width: 767px) {
  .cart-personal__field:nth-of-type(2n+1) {
    margin-right: 0;
  }
}

.cart-personal__field .field__label {
  position: absolute;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
  text-transform: none;
  font-family: var(--font-futura);
  top: 11px;
  left: 16px;
  transition: all 0.3s;
}

.cart-personal__field.required .field__label:after {
  content: '';
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #64c7c3;
  right: -7px;
  top: 1px;
}

.cart-personal__field .field__input:focus ~ .field__label,
.cart-personal__field .field__input.filled ~ .field__label,
.cart-personal__field .field__label--up {
  font-size: 12px;
  line-height: 14px;
  top: -6px;
  left: 10px;
  padding-left: 6px;
  padding-right: 6px;
  background-color: #fff;
}

.cart-personal__field.required .field__input:focus ~ .field__label:after,
.cart-personal__field.required .field__input.filled ~ .field__label:after,
.cart-personal__field.required .field__label--up:after {
  width: 3px;
  height: 3px;
  right: -1px;
}

.cart-personal__field.cart-form__field-wrapper {
  flex-direction: column;
  align-items: flex-start;
}

@media (max-width: 767px) {
  .cart-personal__field.cart-form__field-wrapper {
    order: 1;
  }
}

.cart-personal__field .cart-form__field-tooltip {
  margin-left: 0;
  margin-top: -12px;
}

@media (max-width: 767px) {
  .cart-personal__field .cart-form__field-tooltip {
    position: static;
  }
}

.cart-personal__field .cart-form__field-tooltip-btn {
  color: var(--cl-blue);
  border-bottom-color: var(--cl-blue);
}

.cart-delivery {
  padding-top: 48px;
  padding-bottom: 48px;
}

@media (max-width: 767px) {
  .cart-delivery {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

.cart-payment {
  padding-top: 48px;
  padding-bottom: 48px;
}

@media (max-width: 767px) {
  .cart-payment {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

.cart-total-section {
  padding-top: 48px;
  padding-bottom: 48px;
}

@media (max-width: 767px) {
  .cart-total-section {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

.cart-total-section .cart-total {
  background-color: transparent;
  width: 400px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 767px) {
  .cart-total-section .cart-total {
    width: auto;
  }
}

.cart-total-section .cart-total__wrapper {
  display: block;
  padding: 0;
  margin-bottom: 40px;
}

.cart-total-section .cart-total__block {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  position: relative;
}

.cart-total-section .cart-total__block:last-child {
  margin-bottom: 0;
}

.cart-total-section .cart-total__block:after {
  content: '';
  display: block;
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  border-bottom: 1px dotted #828282;
  z-index: -1;
}

.cart-total-section .cart-total__caption {
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
  color: #828282;
  text-transform: none;
  font-family: var(--font-futura);
  background-color: #fff;
}

@media (max-width: 767px) {
  .cart-total-section .cart-total__caption {
    font-size: 14px;
    line-height: 16px;
  }
}

.cart-total-section .cart-total__sum {
  font-size: 20px;
  line-height: 26px;
  font-weight: 400;
  color: #333;
  text-transform: none;
  font-family: var(--font-futura);
}

@media (max-width: 767px) {
  .cart-total-section .cart-total__sum {
    font-size: 16px;
    line-height: 18px;
  }
}

.cart-total-section .cart-total__sum:after {
  border-color: #333;
}

.cart-total-section .cart-total__sum span {
  background-color: #fff;
}

.cart-total-section .cart-total__sum-caption {
  background-color: #fff;
  font-size: 20px;
  line-height: 26px;
}

@media (max-width: 767px) {
  .cart-total-section .cart-total__sum-caption {
    display: block;
  }
}

.cart-total-section .cart-total__price {
  font-size: 16px;
  line-height: 18px;
  font-weight: 500;
  color: #333;
  text-transform: none;
  font-family: var(--font-futura);
  background-color: #fff;
}

.cart-total-textarea {
  position: relative;
}

@media (max-width: 767px) {
  .cart-total-textarea {
    padding-bottom: 0;
  }
}

.cart-total-textarea textarea {
  width: 100%;
  height: 120px;
  border: 1px solid #e6e6e6;
}

@media (max-width: 767px) {
  .cart-total-textarea textarea {
    height: 180px;
  }
}

.cart-total-textarea .field__label {
  position: absolute;
  top: 13px;
  left: 16px;
  font-size: 16px;
  line-height: 18px;
  color: #333;
  text-transform: none;
  font-family: var(--font-futura);
}

.cart-total-textarea textarea:focus + .field__label {
  font-size: 12px;
  line-height: 14px;
  top: -7px;
  left: 10px;
  padding-left: 6px;
  padding-right: 6px;
  background-color: #fff;
}

.cart-total-section .cart__btn {
  font-family: var(--font-futura-cond);
  width: 250px;
  font-size: 20px;
  font-weight: normal;
}

.cart-total-section .checkbox__label {
  font-size: 16px;
  line-height: 18px;
}

@media (max-width: 767px) {
  .cart-total-section .checkbox__label {
    font-size: 14px;
    line-height: 16px;
  }
}

.cart-total-section .cart-form__field-tooltip-btn {
  color: var(--cl-blue);
  border-color: var(--cl-blue);
}

@media (max-width: 767px) {
  .cart-total-section .cart-form__field-tooltip-btn {
    width: 100%;
  }
}

</style>
